import { render } from "./CreateSectionModal.vue?vue&type=template&id=2e32235a"
import script from "./CreateSectionModal.vue?vue&type=script&lang=js"
export * from "./CreateSectionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__